import { compose } from 'redux';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import { getGameAction } from '../store/actions';
import GamesAdmin from '../components/games/GamesAdmin';


const mapDispatchToProps = ({
    getAGame: getGameAction
});


const mapStateToProps = (state) => {
    return {
        games: state.firestoreData.ordered.games,
        game: state.game ? state.game.data : state.game,
        uid: state.firebaseReducer.auth.uid
    }
}

const MyGamesContainer =  withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => ([
        { 
            collection: 'games' ,
            where: ["ownerId", "==", props.uid],
            orderBy: ['name', 'asc']
        }
      ]))
)(GamesAdmin));

export default MyGamesContainer;